import Link from 'next/link'
import React, { memo } from 'react'

type CheckboxProps = {
  htmlfor: string
  register: any
  require?: any
  required?: any
}

export const Checkbox = memo(
  ({ htmlfor, register, required }: CheckboxProps) => {
    return (
      <>
        <label htmlFor={`${htmlfor}`} className="text-base flex items-center">
          <input
            type="checkbox"
            name=""
            value=""
            id={htmlfor}
            className="checkbox w-0 m-0 opacity-0"
            {...register(htmlfor, {
              required
            })}
          />
          <span className="checkbox_input relative top-0 left-0 rounded-sm block w-[1rem] h-[1rem] border-[#5C5C5C] border border-solid"></span>
          <p className="pl-3 text-left lg:w-full w-[90%]">
            <Link
              href="/privacy-policy/"
              target={'_blank'}
              className="text-[#005990] lg:hover:underline"
            >
              個人情報の取り扱い
            </Link>
            に同意し送信します
          </p>
        </label>
      </>
    )
  }
)
Checkbox.displayName = 'Checkbox'
